import secureLocalStorage from "react-secure-storage";

// export const filterHandler = (value:string, columnName:string, data: Array<any>) => {
//     const filtered = data.filter((row) => {
//       return row[columnName] == value
//     })

//     setTableFilterList(value === 'all' ? data : filtered)

//     if (value == 'all') {
//       form.resetFields(['currecy_filter'])
//     }
//   }

export const secureLocalStorageSet = (key: string, value: any) => {
  secureLocalStorage.setItem(key, value);
};

export const secureLocalStorageGet = (key: string) => {
  return secureLocalStorage.getItem(key);
}

export const secureLocalStorageRemove = (key: string) => {
  return secureLocalStorage.removeItem(key);
}


export const filterHandler = (value: any, columnName: string, data: Array<any>) => {
  const filtered = data.filter((row) => {
    return row[columnName] == value
  })
  return filtered
}
// let resultArr:Array<object> = []
export const uniqueFilterArr = (optionsArr: Array<object>, resultArr: Array<object>) => {
  optionsArr.filter(function (item: object) {
    var i = resultArr.findIndex((x: any) => (x.value == item.value));
    if (i <= -1) {
      resultArr.push(item);
    }
  });
  return resultArr;
}

